// const isProd = process.env.NODE_ENV === 'production'
import store from '@/store/index'
import axios from 'axios'
import { Message } from 'element-ui'
// import SecurityService from './SecurityService'
const customError = {
  '401': 'Unauthorized',
  '404': 'Not Found',
  '500': 'Service Error',
  '590': 'please check params!',
  '514': 'Have unprocessed orders',
  '405': 'Password Not Match',
  '406': 'User Not Found',
  '407': 'Params Not Match',
  '408': 'New Password And Confirm Password Not Match',
  '409': 'Old Password And Secret Not Match',
  '410': 'Parameters Missing',
  '411': 'User Already Exits',
  '412': 'Password Length Not At 6-16',
  '413': 'Field Not Unique',
  // '501': 'Not Implemented',
  '1000': 'Generic',
  '5001': 'DB Error'
}
const langMap = {
  'zh-hans': 'zh-CN',
  'zh-hant': 'zh-HK',
  cn: 'zh-CN',
  hk: 'zh-HK',
  en: 'en-US'
}
const service = axios.create({
  // baseURL: process.env.VUE_APP_CLIENT_SERVER_URL, // api 的 base_url
  timeout: 30000 // request timeout
})
// 添加请求拦截器
service.interceptors.request.use(
  // 给全局请求头配置token
  async config => {
    let accessToken = store.state.accessToken
    // console.log(accessToken, 'accessTokenaccessTokenaccessToken')
    // let idToken = localStorage.getItem('id_token')

    let baseUrl =
      config.url !== 'uploads/base64' &&
      config.url !== '/v2/sms-code' &&
      config.url !== '/v2/token' &&
      config.url !== '/v2/logout'
        ? process.env.VUE_APP_BASE_URL
        : ''
    config.baseURL = process.env.VUE_APP_CLIENT_SERVER_URL + baseUrl
    // config.baseURL = process.env.VUE_APP_CLIENT_PORTAL_NEW_API
    // if (accessToken) config.headers['X-Token'] = accessToken
    // config.headers['Id-Token'] = idToken
    // console.log(config.url, 'config.url ')
    // config.headers['Authorization'] =
    if (config.url.indexOf('http') < 0 || config.url.indexOf('logout') > 0) {
      config.headers['Authorization'] = 'Bearer ' + accessToken
    }
    config.url =
      config.url.indexOf('?') < 0
        ? config.url + '?platform=Web'
        : config.url + '&platform=Web'
    config.headers['accept-language'] =
      langMap[sessionStorage.getItem('language')] || 'zh-CN'
    config.headers['platform'] = 'CP_WEB'
    return config
  }
)
service.interceptors.response.use(
  response => response.data,
  error => {
    console.log('>>>>>error.response<<<<<', error)
    if (error.message.includes('timeout')) {
      // 判断请求异常信息中是否含有超时timeout字符串
      return Promise.reject(error)
      // return Promise.reject(error) // reject这个错误信息
    } else if (
      error &&
      error.response &&
      error.response.data &&
      error.response.data.code === 401
    ) {
      // 401的时候跳转到登录页
      localStorage.clear()
      sessionStorage.clear()
      window.location.href = `${process.env.VUE_APP_AUTH}/login.html?client_id=account_center&client_secret=abcd&redirect_uri=${process.env.VUE_APP_CALLBACKURL}&state=sdfsfs&scope=basic&response_type=code&signup_uri=${process.env.VUE_APP_SIGNUP_URI}`
      // window.location.href = 'https://eddid-auth-center-uat.eddid.com.cn:1443/login.html?client_id=account_center&client_secret=abcd&redirect_uri=https%3A%2F%2Ftest1.local%3A8080%2Fhome&state=sdfsfs&scope=basic&response_type=code'
    } else if (
      error &&
      error.response &&
      error.response.data &&
      customError[error.response.data.code]
    ) {
      error.response.message = customError[error.response.status]
      Message.error(customError[error.response.data.code])
      return Promise.reject(customError[error.response.data.code])
    } else {
      // let errorResponse = null
      // return Promise.reject(errorResponse)
      // eslint-disable-next-line prefer-promise-reject-errors
      Message.error(
        (error &&
          error.response &&
          error.response.data &&
          error.response.data.msg) ||
          '网络异常,请稍后再试！'
      )
      return Promise.reject(
        (error && error.response && error.response.data && error.response.data.msg) ||
          '网络异常,请稍后再试！'
      )
    }
  }
)

export default service
